import React, { createContext, useContext, useState, useEffect } from 'react'

import axios from 'axios'

const apiUrl = process.env.REACT_APP_API_URL

const ProductsContext = createContext(null)

export const useProducts = () => useContext(ProductsContext)

export const ProductsProvider = ({ children }) => {
    const [loadingProducts, setLoadingProducts] = useState(false)
    const [products, setProducts] = useState([])
    const [productsError, setProductsError] = useState(null)

    const fetchProducts = async () => {
        try {
            setLoadingProducts(true)
            const response = await axios.get(`${apiUrl}/products`, {
                withCredentials: true
            })
            const { data: { products } } = response
            setLoadingProducts(false)
            setProducts(products)
        } catch (error) {
            setLoadingProducts(false)
            setProductsError(error?.response?.data?.message || 'Error fetching plans')
        }
    }

    useEffect(() => {
        fetchProducts()
    }, [])

    return (
        <ProductsContext.Provider value={{ products, productsError, loadingProducts }}>{children}</ProductsContext.Provider>
    )
}
